import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";
import {
  createMockAuthorizationExportResponse,
  isAuthorizationExportMockEnabled,
} from "./authorizationExportMockService";

export const postsService = {
  get: async (search, token, page = 1) => {
    const response = await https.get(API_ROUTES.POSTS.GET, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        search_value: search,
        page: page,
      },
    });
    return response;
  },
  get_by_id: async (post_id, token) => {
    const response = await https.get(
      `${API_ROUTES.POSTS.GET_BY_ID}/${post_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_posts: async (token, params) => {
    const response = await https.get(`${API_ROUTES.POSTS.GET_POSTS}`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return response;
  },
  get_post_by_id: async (postId, token) => {
    const response = await https.get(
      `${API_ROUTES.POSTS.GET_POSTS_BY_ID.replace(":postId", postId)}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  exportAuthorizationFile: async (postId, data, token) => {
    if (isAuthorizationExportMockEnabled()) {
      return createMockAuthorizationExportResponse(postId, data);
    }

    const response = await https.post(
      API_ROUTES.POSTS.EXPORT_AUTHORIZATION_FILE.replace(":postId", postId),
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      },
    );
    return response;
  },
  create: async (data, token) => {
    const response = await https.post(API_ROUTES.POSTS.CREATE, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  update: async (post_id, data, token) => {
    const response = await https.put(
      `${API_ROUTES.POSTS.UPDATE}/${post_id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  delete: async (post_id, token) => {
    const response = await https.delete(
      `${API_ROUTES.POSTS.DELETE}/${post_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },

};
